// extracted by mini-css-extract-plugin
module.exports = {"panel":"search-panel_panel__2ug4N","header":"search-panel_header__2luu3","body":"search-panel_body__19eJT"};